{
  "familyId": "GET-BREUK-LEZEN",
  "questions": [
    {
      "id": "GET-BREUK-LEZEN-001",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je de breuk $\\frac{3}{5}$?",
      "options": [
        "drie vijfde",
        "vijf derde",
        "drie van vijf",
        "drie komma vijf"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 5,
            "label": "De breuk 3/5"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk lezen",
            "content": "Lees eerst de teller (boven), dan de noemer (onder) met '-de' of '-ste' erachter. Teller = 'hoeveel', noemer = 'welk soort deel'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Lees eerst de teller (boven), dan de noemer (onder) met '-de' erachter. De teller is 3 → 'drie'. De noemer is 5 → 'vijfde'. Samen: 'drie vijfde'. De teller vertelt hoeveel delen, de noemer vertelt welk soort deel.",
        "solutionSteps": [
          "De teller is 3 → 'drie'",
          "De noemer is 5 → 'vijfde'",
          "Samen: 'drie vijfde'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{5}$ lees je als 'drie vijfde' — 3 (teller) delen van 5 (noemer).",
          "1": "Je dacht waarschijnlijk dat je de noemer eerst leest. Maar bij $\\frac{3}{5}$ is 3 de teller (boven) en 5 de noemer (onder). Onthoud: lees altijd eerst de teller, dan de noemer met '-de' erachter.",
          "2": "Je dacht waarschijnlijk dat je 'van' gebruikt. Maar de wiskundige manier is 'drie vijfde', niet 'drie van vijf'. Onthoud: 'drie van vijf' klinkt als een score, niet als een breuk.",
          "3": "Je dacht waarschijnlijk dat dit een kommagetal is. Maar $\\frac{3}{5}$ is een breuk ('drie vijfde'), niet het kommagetal 3,5. Onthoud: $\\frac{3}{5}$ = 0,6 als kommagetal."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-002",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'twee zevende'?",
      "options": [
        "$\\frac{2}{7}$",
        "$\\frac{7}{2}$",
        "$\\frac{2}{9}$",
        "$\\frac{1}{7}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 7,
            "label": "Schrijf de breuk: twee zevende"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk schrijven",
            "content": "Het eerste woord is de teller (boven de streep). Het tweede woord geeft de noemer (onder de streep). 'Twee zevende' → teller 2, noemer 7.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het eerste woord is de teller, het tweede woord geeft de noemer. 'Twee' → teller = 2. 'Zevende' → noemer = 7. Schrijf als $\\frac{2}{7}$.",
        "solutionSteps": [
          "'Twee' → teller = 2",
          "'Zevende' → noemer = 7",
          "Schrijf als $\\frac{2}{7}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Twee zevende' = teller 2, noemer 7 = $\\frac{2}{7}$.",
          "1": "Je dacht waarschijnlijk dat de noemer bovenaan staat. Maar 'twee zevende' → 2 boven, 7 onder = $\\frac{2}{7}$. Onthoud: bij $\\frac{7}{2}$ zou je 'zeven halve' zeggen.",
          "2": "Je dacht waarschijnlijk dat 'zevende' bij 9 hoort. Maar zevende = 7, negende = 9. Onthoud: luister goed naar het woord — zeven → zevende.",
          "3": "Je dacht waarschijnlijk dat de teller 1 is. Maar 'twee zevende' heeft teller 2, niet 1. Onthoud: 'eén zevende' zou $\\frac{1}{7}$ zijn."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-003",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{1}{2}$?",
      "options": [
        "een half",
        "een tweede",
        "twee eerste",
        "een komma twee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "De breuk 1/2"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijzondere breuknamen",
            "content": "Sommige breuken hebben een speciale naam: ½ = 'een half', ¼ = 'een kwart', ¾ = 'drie kwart'. Deze namen moet je onthouden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "$\\frac{1}{2}$ is een bijzondere breuk met een speciale naam. We zeggen 'een half' (niet 'een tweede'). Andere bijzondere namen: $\\frac{1}{4}$ = 'een kwart', $\\frac{3}{4}$ = 'drie kwart'.",
        "solutionSteps": [
          "$\\frac{1}{2}$ is een bijzondere breuk",
          "De speciale naam is 'een half'",
          "Andere bijzondere namen: ¼ = 'een kwart', ¾ = 'drie kwart'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ lees je als 'een half'. Dit is een bijzondere breuknaam die je moet onthouden.",
          "1": "Je dacht waarschijnlijk dat de gewone regel geldt. Wiskundig klopt 'een tweede', maar in het dagelijks taalgebruik zeggen we 'een half'. Onthoud: net zoals we 'een kwart' zeggen in plaats van 'een vierde'.",
          "2": "Je dacht waarschijnlijk dat je de noemer eerst leest. Maar bij $\\frac{1}{2}$ is 1 de teller en 2 de noemer. Onthoud: 'twee eerste' zou $\\frac{2}{1}$ zijn (= 2 hele).",
          "3": "Je dacht waarschijnlijk dat dit een kommagetal is. Maar $\\frac{1}{2}$ = 'een half' = 0,5. Onthoud: 'een komma twee' zou 1,2 zijn — dat is iets heel anders."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-004",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'vijf achtste'?",
      "options": [
        "$\\frac{5}{8}$",
        "$\\frac{8}{5}$",
        "$\\frac{5}{3}$",
        "$\\frac{58}{1}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "Schrijf de breuk: vijf achtste"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Een breuk schrijven",
            "content": "Het eerste woord is de teller (boven de streep). Het tweede woord geeft de noemer (onder de streep). 'Vijf achtste' → teller 5, noemer 8.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het eerste woord is de teller, het tweede woord geeft de noemer. 'Vijf' → teller = 5. 'Achtste' → noemer = 8. Schrijf als $\\frac{5}{8}$.",
        "solutionSteps": [
          "'Vijf' → teller = 5",
          "'Achtste' → noemer = 8",
          "Schrijf als $\\frac{5}{8}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vijf achtste' = teller 5, noemer 8 = $\\frac{5}{8}$.",
          "1": "Je dacht waarschijnlijk dat de noemer bovenaan staat. Maar 'vijf achtste' → 5 boven, 8 onder. Onthoud: $\\frac{8}{5}$ zou 'acht vijfde' zijn.",
          "2": "Je dacht waarschijnlijk dat 'achtste' bij 3 hoort. Maar achtste = 8, derde = 3. Onthoud: luister goed — acht → achtste.",
          "3": "Je dacht waarschijnlijk dat de getallen als één getal gelezen worden. Maar 'vijf achtste' is een breuk met teller 5 en noemer 8, niet het getal 58. Onthoud: een breuk heeft altijd een teller en een noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-005",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{3}{4}$?",
      "options": [
        "drie kwart",
        "drie vierde",
        "vier derde",
        "driekwart procent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "De breuk 3/4"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bijzondere breuknamen",
            "content": "Bij noemer 4 zeggen we 'kwart': ¼ = een kwart, ²⁄₄ = twee kwart (= een half), ¾ = drie kwart.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 5,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "$\\frac{3}{4}$ is een bijzondere breuk met een speciale naam. Noemer 4 → we zeggen 'kwart' (niet 'vierde'). Teller 3 → 'drie'. Samen: 'drie kwart'. Onthoud: $\\frac{1}{4}$ = een kwart, $\\frac{2}{4}$ = twee kwart (= een half), $\\frac{3}{4}$ = drie kwart.",
        "solutionSteps": [
          "Noemer 4 → we zeggen 'kwart'",
          "Teller 3 → 'drie'",
          "Samen: 'drie kwart'"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ lees je als 'drie kwart'. Dit is de gebruikelijke naam voor breuken met noemer 4.",
          "1": "Je dacht waarschijnlijk dat de gewone regel geldt. 'Drie vierde' is wiskundig correct, maar in het Nederlands zeggen we 'drie kwart'. Onthoud: net zoals we 'een half' zeggen in plaats van 'een tweede'.",
          "2": "Je dacht waarschijnlijk dat je de noemer eerst leest. Maar bij $\\frac{3}{4}$ is 3 de teller (boven) en 4 de noemer (onder). Onthoud: 'vier derde' zou $\\frac{4}{3}$ zijn.",
          "3": "Je dacht waarschijnlijk dat 'kwart' iets met procenten te maken heeft. Maar drie kwart ($\\frac{3}{4}$) = 75%, maar het is geen procent. Onthoud: een breuk en een percentage zijn verschillende manieren om hetzelfde te schrijven."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-006",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "matching",
      "question": "Koppel elke breuk aan de juiste naam.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "$\\frac{1}{4}$", "right": "een kwart" },
          { "left": "$\\frac{2}{3}$", "right": "twee derde" },
          { "left": "$\\frac{1}{2}$", "right": "een half" },
          { "left": "$\\frac{5}{6}$", "right": "vijf zesde" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken en hun namen",
            "content": "Lees de teller (boven) en de noemer (onder) met '-de' of '-ste' erachter. Bijzondere namen: ½ = 'een half', ¼ = 'een kwart'. Gewone namen: ⅔ = 'twee derde', ⅚ = 'vijf zesde'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_naam_koppelen",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "$\\frac{1}{4}$ = 'een kwart' (bijzondere naam). $\\frac{2}{3}$ = 'twee derde' (teller + noemer met -de). $\\frac{1}{2}$ = 'een half' (bijzondere naam). $\\frac{5}{6}$ = 'vijf zesde' (teller + noemer met -de).",
        "solutionSteps": [
          "$\\frac{1}{4}$ → noemer 4 = 'kwart' → 'een kwart'",
          "$\\frac{2}{3}$ → teller 2, noemer 3 = 'derde' → 'twee derde'",
          "$\\frac{1}{2}$ → noemer 2 = 'half' → 'een half'",
          "$\\frac{5}{6}$ → teller 5, noemer 6 = 'zesde' → 'vijf zesde'"
        ]
      }
    },
    {
      "id": "GET-BREUK-LEZEN-007",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "fill_in",
      "question": "Schrijf de breuk 'vier negende' als breuk. Typ als teller/noemer (bijv. 3/5).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["4/9", "⁴⁄₉"],
        "caseSensitive": false,
        "placeholder": "Typ de breuk..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuk schrijven",
            "content": "Het eerste woord is de teller (boven de streep). Het tweede woord geeft de noemer (onder de streep). 'Vier negende' → teller = 4, noemer = 9 → 4/9.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_schrijven_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "'Vier' is de teller (boven de streep) = 4. 'Negende' geeft de noemer (onder de streep) = 9. De breuk is $\\frac{4}{9}$.",
        "solutionSteps": [
          "'Vier' → teller = 4",
          "'Negende' → noemer = 9",
          "Schrijf als $\\frac{4}{9}$ of 4/9"
        ]
      }
    }
  ]
}